import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";


// Get Table Data
export const STPEnergyMPCNoTableDataAPI = createAsyncThunk("STPEnergyMPCNoTableData", async ({ data }) => {
    const {
        M_STP_EnergyMPCNoID,
        M_WardID,
        M_UserID,
        token,
        From,
        To,
        handleSTPEnergyMPCNoExport
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/Master/Get_WEB_M_STP_EnergyMPCNo_Select?M_WardID=${M_WardID ? M_WardID : '0'}&M_STP_EnergyMPCNoID=${M_STP_EnergyMPCNoID ? M_STP_EnergyMPCNoID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleSTPEnergyMPCNoExport && handleSTPEnergyMPCNoExport()
                return result.data

            } else {
                return result
            }
        })
})

const STPEnergyMPCNoTableDataSlice = createSlice({
    name: "STPEnergyMPCNoTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPEnergyMPCNoTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(STPEnergyMPCNoTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(STPEnergyMPCNoTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const STPEnergyMPCNoTableDataReducer = STPEnergyMPCNoTableDataSlice.reducer


export const STPEnergyMPCNoTableExportDataAPI = createAsyncThunk("STPEnergyMPCNoTableExportData", async ({ data }) => {
    const {
        M_STP_EnergyMPCNoID,
        M_WardID,
        M_UserID,
        token,
        From,
        To,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/Master/Get_WEB_M_STP_EnergyMPCNo_Select?M_WardID=${M_WardID ? M_WardID : '0'}&M_STP_EnergyMPCNoID=${M_STP_EnergyMPCNoID ? M_STP_EnergyMPCNoID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data

            } else {
                return result
            }
        })
})

const STPEnergyMPCNoTableExportDataSlice = createSlice({
    name: "STPEnergyMPCNoTableExportData",
    initialState: {
        isExportLoading: false,
        ExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPEnergyMPCNoTableDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(STPEnergyMPCNoTableDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExportTableData = action.payload;
        });
        builder.addCase(STPEnergyMPCNoTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExportTableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const STPEnergyMPCNoTableExportDataReducer = STPEnergyMPCNoTableExportDataSlice.reducer


export const STPEnergyMPCNoPostDataAPI = createAsyncThunk("STPEnergyMPCNoPostData", async ({ data }) => {
    const {
        M_STP_EnergyMPCNoID,
        M_WardID,
        EnergyMPCNo,
        M_UserID,
        token,
        Flag,
        handleIsPost,
        handleClearField,
        handleOnCloseClick,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("M_STP_EnergyMPCNoID", M_STP_EnergyMPCNoID);
    formdata.append("M_WardID", M_WardID);
    formdata.append("EnergyMPCNo", EnergyMPCNo);
    formdata.append("M_UserID", M_UserID);
    formdata.append("Flag", Flag);

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/Master/Post_WEB_M_STP_EnergyMPCNo_InsertUpdate`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                // handleClearField()
                handleOnCloseClick()
                toastSuccesss(result.message)
                return result.data
            } else {
                toastErrorr(result.message)
            }
            return result
        })
})

const STPEnergyMPCNoPostDataSlice = createSlice({
    name: "STPEnergyMPCNoPostData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPEnergyMPCNoPostDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(STPEnergyMPCNoPostDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(STPEnergyMPCNoPostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const STPEnergyMPCNoPostDataReducer = STPEnergyMPCNoPostDataSlice.reducer

// -----------------Delete API ---------------

export const STPEnergyMPCNoDeleteAPI = createAsyncThunk("STPEnergyMPCNoDelete", async ({ data }) => {
    const {
        M_STP_EnergyMPCNoID,
        M_UserID,
        token,
        handleIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);


    var formdata = new FormData();
    formdata.append("M_STP_EnergyMPCNoID", M_STP_EnergyMPCNoID);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/Master/WEB_M_STP_EnergyMPCNo_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const STPEnergyMPCNoDeleteSlice = createSlice({
    name: "STPEnergyMPCNoDelete",
    initialState: {
        isDeleteLoading: false,
        SectorData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPEnergyMPCNoDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(STPEnergyMPCNoDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.SectorData = action.payload;

        });
        builder.addCase(STPEnergyMPCNoDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.SectorData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const STPEnergyMPCNoDeleteReducer = STPEnergyMPCNoDeleteSlice.reducer